// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"f1066208","198":"9cd20ca9","325":"43d7016d","379":"5327a932","453":"c63328af","493":"ad951212","760":"be7defbb","900":"d6c309a4","935":"6f0760b9"}[chunkId] + ".chunk.js";
};